import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  findLessonByLessonType,
  LESSON_TYPES,
  useDeleteLessonMutation,
} from 'features/classCreation';
import CreateLessonModal from '../CreateLessonModal';
import Switch from 'components/Switch';

function DiscussionSwitch({ academyTopic }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLesson, { isSuccess, error }] = useDeleteLessonMutation();
  const lessons = academyTopic.lessons;
  const discussion = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.liveLecture,
  });

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully deleted!');
    }
  }, [error, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleLessonDelete = useCallback(() => {
    if (window.confirm('Are you sure, you want to delete this lesson?')) {
      deleteLesson({
        lessonId: discussion?.id,
        academyTopicId: academyTopic.id,
      });
    }
  }, [academyTopic.id, deleteLesson, discussion?.id]);

  const handleOnChange = useCallback(
    (event) => {
      if (event.target.checked) {
        handleModalOpen();
      } else {
        handleLessonDelete();
      }
    },
    [handleLessonDelete, handleModalOpen]
  );

  return (
    <>
      <CreateLessonModal
        title="Discussion"
        handleClose={handleModalClose}
        lessonType={LESSON_TYPES.liveLecture}
        isOpen={modalOpen}
        academyTopicId={academyTopic.id}
      />
      <Switch
        checked={Boolean(discussion)}
        onChange={handleOnChange}
        className="m-l-xs"
        small
      />
    </>
  );
}

export default DiscussionSwitch;
